import React from "react";
import { Typography, Grid, CardMedia, makeStyles } from "@material-ui/core";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    justifyContent: "center",
    marginTop: "1em",
  },
  grid: {
    margin: "4em",
    [theme.breakpoints.down("sm")]: {
      margin: "0.5em",
      textAlign: "center",
    },
  },

  header: {
    marginBottom: "1.2em",
    marginTop: "1.1em",
  },
  paragraph: {
    lineHeight: "1.6em",
    [theme.breakpoints.down("xs")]: {
      marginRight: "1.2em",
    },
  },
  media: {
    marginTop: "3em",
    height: "21em",
    borderRadius: "0.3em",
  },
}));

const HowItWorks = () => {
  const classes = useStyles();
  return (
    <>
      <NtkHeader header="How It Works" />
      <NtkParagraph
        paragraph="NaTakallam offers online conversation and tuition practice in 5 languages for your team. We also
                offer virtual sessions which provide open conversation about CPs’ personal stories, the context that
                forced him/her to leave, the challenges of rebuilding a life."
      />
      <Grid container className={classes.gridContainer}>
        <Grid item xs={12} sm={10} md={8} lg={4} className={classes.grid}>
          <Typography className={classes.header} color="primary" variant="h2">
            1. Tell us about you
          </Typography>

          <Typography
            className={classes.paragraph}
            variant="h3"
            color="secondary"
          >
            Tell us about your organization and your needs, and we’ll get in
            touch with a tailored solution to meet your team needs.
          </Typography>
          <CardMedia className={classes.media} image={require("./ntk1.png")} />
        </Grid>

        <Grid item xs={12} sm={10} md={8} lg={4} className={classes.grid}>
          <CardMedia className={classes.media} image={require("./ntk1.png")} />

          <Typography className={classes.header} color="primary" variant="h2">
            2. We’ll get in touch and start piloting
          </Typography>

          <Typography
            className={classes.paragraph}
            variant="h3"
            color="secondary"
          >
            Tell us about your organization and your needs, and we’ll get in
            touch with a tailored solution to meet your team needs.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
export default HowItWorks;
